// セッション録画の文字マスクは属性値に効かないため、スレッド名・ファイル名・患者情報など
// ユーザー由来の値を属性に持つ要素は、このクラスで録画から外す(PostHog の既定の blockClass)。
export const SESSION_RECORDING_BLOCKED_CLASS = "ph-no-capture";
